import { render, staticRenderFns } from "./AiInvoiceAccountingValueTypeList.vue?vue&type=template&id=06d84779&scoped=true&"
import script from "./AiInvoiceAccountingValueTypeList.vue?vue&type=script&lang=js&"
export * from "./AiInvoiceAccountingValueTypeList.vue?vue&type=script&lang=js&"
import style0 from "./AiInvoiceAccountingValueTypeList.vue?vue&type=style&index=0&id=06d84779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d84779",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VDataTable,VIcon,VSkeletonLoader,VTooltip})
